import EditingContext from '../contexts/EditingContext';
import { useContext } from 'react';

export const useEditingContext = () => {
  return useContext(EditingContext);
};
